// services/api.js
// Configuration du client Axios pour communiquer avec le backend
import axios from 'axios';

// URL de base de l'API (peut être modifiée via .env)
// Par défaut : /api
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Création d'une instance Axios avec la configuration de base
const api = axios.create({
  baseURL: API_BASE_URL,    // Toutes les requêtes partiront de cette URL
  headers: {
    'Content-Type': 'application/json',  // Format JSON par défaut
  },
});

// Intercepteur pour ajouter le token d'authentification (si nécessaire plus tard)
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem('token');
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

export default api;
